import { NotificationProps } from '@/components/Notification'
import { nanoid } from 'nanoid'
import { create } from 'zustand'

type Notifcation = Required<Omit<NotificationProps, 'handleClose'>> & {
  id: string
}
type NotifcationStore = {
  notifcations: Notifcation[]
  closeNotifcation: (id: string) => void
  addNotifcation: (notifcation: Omit<Notifcation, 'id'>) => void
}
export const useNotificationStore = create<NotifcationStore>((set) => ({
  notifcations: [],
  addNotifcation: (notification) =>
    set((state) => ({
      notifcations: [...state.notifcations, { ...notification, id: nanoid() }],
    })),
  closeNotifcation: (id) =>
    set((state) => ({
      notifcations: state.notifcations.filter(
        (notifcation) => notifcation.id !== id
      ),
    })),
}))
